import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import injectTapEventPlugin from 'react-tap-event-plugin';
import registerServiceWorker from './registerServiceWorker';

import App from './App';
import configureStore from './utils/store';

import 'normalize.css';
import './styles/style.css';

import * as debugApi from "./Atollon/debug";
import {getChangePasswordRedirectUrl} from "./constants";

function redirect_somewhere_else()
{
    // globe_forgotten_password
    if (/[?&;]changePassword=.+/.test(window.location.href))
    {
        window.location = getChangePasswordRedirectUrl();
        return true;
    }
    else
    {
        return false;
    }
}

if( ! redirect_somewhere_else())
{
    injectTapEventPlugin();

    const store = configureStore();

    render(<App store={store} />, document.getElementById('root'));
    registerServiceWorker();
}



// WEBPACK FOOTER //
// ./src/index.js